<script setup>
import EmailingConfigurationForm from '@frontJs/components/forms/projectManagement/modules/EmailingConfigurationForm.vue';
import EmailingExclusionTable from '@frontJs/components/tables/projectManagement/modules/EmailingExclusionTable.vue';
import EmailingGeneralStatisticsTable from '@frontJs/components/tables/projectManagement/modules/EmailingGeneralStatisticsTable.vue';
import EmailingTable from '@frontJs/components/tables/projectManagement/modules/EmailingTable.vue';
import EmailingUnsubscriptionTable from '@frontJs/components/tables/projectManagement/modules/EmailingUnsubscriptionTable.vue';
import EmailingVariableTable from '@frontJs/components/tables/projectManagement/modules/EmailingVariableTable.vue';
import TenantReportEmailingTable from '@frontJs/components/tables/projectManagement/modules/tenantReports/EmailingTable.vue';
import SegmentationTable from '@frontJs/components/tables/projectManagement/sem/SegmentationTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
    configuration: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Emailings - Modules - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - Modules - Emailings
    </PageTitle>

    <TabLayout
        v-if="tenant"
        :tabs="{
            emailings: {
                title: 'Emailings',
                content: h(EmailingTable, { tenant }),
            },
            statistics: {
                title: 'Statistiques',
                content: h(EmailingGeneralStatisticsTable, { tenant }),
            },
            variables: {
                title: 'Variables',
                content: h(EmailingVariableTable, { tenant }),
            },
            blacklist: {
                title: 'Liste noire',
                content: h(EmailingExclusionTable, { tenant }),
            },
            unsubscriptions: {
                title: 'Désabonnements',
                content: h(EmailingUnsubscriptionTable, { tenant }),
            },
            segmentations: {
                title: 'Segmentations',
                content: h(SegmentationTable, { tenant }),
            },
            configuration: {
                title: 'Configuration',
                content: h(EmailingConfigurationForm, {
                    tenant,
                    configuration,
                }),
            },
        }"
    />

    <TabLayout
        v-else
        :tabs="{
            emailings: {
                title: 'Emailings',
                items: {
                    perCustomer: {
                        title: 'Par client',
                        content: h(TenantReportEmailingTable),
                    },
                    all: {
                        title: 'Tous',
                        content: h(EmailingTable, { all: true }),
                    },
                },
            },
            statistics: {
                title: 'Statistiques',
                content: h(EmailingGeneralStatisticsTable, { all: true }),
            },
        }"
    />
</template>
